import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { PATHS, navigate } from '@client/routes';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const withSettingsLayout =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (Component: any, page: 'profile' | 'account') => (props: any) => {
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
      if (newValue == 'profile') {
        navigate(PATHS.CREATOR.PROFILE());
      } else if (newValue == 'account') {
        navigate(PATHS.CREATOR.SETTINGS);
      }
    };

    return (
      <div>
        <div style={{ maxWidth: '720px' }}>
          <Tabs
            value={page}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Profile" {...a11yProps(0)} value="profile" />
            <Tab label="Settings" {...a11yProps(1)} value="account" />
          </Tabs>
          <Component {...props} />
        </div>
      </div>
    );
  };
